import { types } from './actions';

const initialState = {
  quoteItemId: null,
  componentId: null,
  isQuantitiesUpdating: false,
  error: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.QUANTITIES_MODAL_CLOSE:
    case types.UPDATE_QUANTITIES_SUCCESS:
      return {
        ...initialState,
      };
    case types.QUANTITIES_MODAL_OPEN:
      return {
        ...state,
        quoteItemId: payload.quoteItemId,
        componentId: payload.componentId,
        error: null,
      };
    case types.UPDATE_QUANTITIES_REQUEST:
      return {
        ...state,
        isQuantitiesUpdating: true,
        error: null,
      };
    case types.UPDATE_QUANTITIES_ERROR:
      return {
        ...state,
        isQuantitiesUpdating: false,
        error: payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
